import { ValidatedComponent } from "./validatedComponent"

export function registerInlineValidationListener(
    component: ValidatedComponent,
    inlineValidationListener: (abortSignal: AbortSignal) => void,
    validationVisibilityHandler?: () => boolean,
) {
    const visibilityHandler = validationVisibilityHandler ? validationVisibilityHandler : () => true
    const hasServerSideError = component.hasError
    let ignoreVisibilityHandler = hasServerSideError
    const validateDirectly = hasServerSideError || validationVisibilityHandler != undefined
    let abortController: AbortController
    const performValidationAndHandleVisibility = () => {
        if (abortController) {
            abortController.abort()
        }
        abortController = new AbortController()
        inlineValidationListener(abortController.signal)
        if (!ignoreVisibilityHandler) {
            component.shouldShowError = visibilityHandler()
        }
    }
    const focusListener = () => {
        if (!component.shouldShowError && visibilityHandler()) {
            component.shouldShowError = true
        }

        registerEventListenerOnFields(component.allFields, "input", performValidationAndHandleVisibility)
        if (!component.hasError) {
            performValidationAndHandleVisibility()
        }
    }
    const validationActivatingFields = component.validationActivatingFields || component.allFields
    if (validateDirectly) {
        registerEventListenerOnFields(component.allFields, "input", performValidationAndHandleVisibility)
        /*                                      */
        registerEventListenerOnFields(component.allFields, "focusin", focusListener)
    } else {
        registerEventListenerOnFields(validationActivatingFields, "focusout", focusListener)
    }

    /*                                                    */
    registerEventListenerOnFields(validationActivatingFields, "focusout", () => {
        ignoreVisibilityHandler = true
        component.shouldShowError = true
    })
}
function registerEventListenerOnField(field: HTMLElement, eventType: string, listener: () => void) {
    field.removeEventListener(eventType, listener)
    field.addEventListener(eventType, listener)
}
function registerEventListenerOnFields(fields: HTMLElement[], eventType: string, listener: () => void) {
    fields.forEach((field) => {
        registerEventListenerOnField(field, eventType, listener)
    })
}
